import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';

import store from '../../store';
import seluxLogo from '../../../icons/selux-logo';
import {selectSolarPrice} from '../../solar/solarSelectors';

@customElement('shared-specsheet-footer')
export class SharedSpecsheetFooter extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin-top: auto;
				line-height: 1.4;
			}

			.footer {
				font: var(--font-specsheet-print-small-light);
				font-size: 0.6cqw;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				margin: 0;
				align-items: end;
				width: 100%;
				gap: 2cqw;

			}
			p {
				margin: 0;
				padding: 0;
			}

			.footer-text {
				width: 85%;
			}

			.logo {
				width: 4cqw;
				display: block;
				vertical-align: bottom;
			}

			.address {

			}

			.address span {
				font-weight: bold;
			}

			.date {
			}

			.price {
			}

		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.family = state.status.family;
		this.isDetail = state.status.specsheetType === 'detail';
		this.southernHemisphare = state.solar.data?.project?.location?.latitude < 0;
		this.price = state.price.data.totalPriceInEuro;
	}
	currentDate() {
		const now = new Date();
		return (now.getDate()) + '.' + (now.getMonth() + 1) + '.' + now.getFullYear();
	}
	render() {
		const s = this.state;
		return html`
			<div class="footer">
				<div class="flex-item footer-text">
					<p>
						${when(this.family === 'Aeto', () => html`
							${when(!this.southernHemisphare,
								() => html`${msg('Reference day: winter 21.dec, summer 21.jul, spring/autumn: 21.sep')} ${selectSolarPrice(s)}<br>`,
								() => html`${msg('Reference day: summer 21.dec, winter 21.jul, spring/autumn: 21.sep')} ${selectSolarPrice(s)}<br>`,
							)}
						`)}
						<trans-label key="TE_Footer" context="D.L"></trans-label>
						<span class="date">${this.currentDate()}</span>
						${when(this.isDetail, () => html`
							<span class="price">${this.price}</span>
						`)}

					</p>
					<p class="address">
						<span>Selux GmbH, Volkmarstraße 18, D-12099 Berlin, T +49 30 72001-0, F -100, info@selux.com, www.selux.com</span>
					</p>
				</div>

				<div class="flex-item logo">
					${seluxLogo}
				</div>
			</div>
		`;
	}
}
